export const UI_TABLE_LIST_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const UI_TABLE_LIST_PAGE_SIZE_DEFAULT = 10;

// UiNotify
export const ERROR = 'error';
export const SUCCESS = 'success';
export const WARN = 'warn';
export const INFO = 'info';
